

























import { Vue, Component, Prop } from 'vue-property-decorator'
import { closeJob } from '@/services/jobs'

@Component
export default class CloseJobDialog extends Vue {
  loading = false

  @Prop({ default: false }) readonly opened!: boolean
  @Prop({ type: Number, required: true }) readonly jobId!: number

  get job() {
    return this.$store.getters.job(this.jobId)
  }

  closeDialog() {
    this.$emit('update:opened', false)
  }

  async closeJob() {
    this.loading = true
    try {
      await closeJob(this.$store, this.job.id)
      this.closeDialog()
      if (this.$route.name !== 'jobs')
        this.$router.push({name: 'jobs'})
    }
    finally {
      this.loading = false
    }
  }
}
